import { Grid, Typography } from "@mui/material";
import { Card } from "components/ui";
import { usePermissions } from "context/PermissionsContext";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";

const archives = [
  { name: "Limits by User", path: "limitUser" },
  { name: "Limits by Client", path: "limitClient" },
];

const LimitsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let preState = location.state;

  const handleClick = (name, path) => {
    
    const state = { ...preState, name: [preState.name && preState.name[0], `${name}`] };

    navigate(`/Setting/limits/${path}`, { state });
  };

  const style = {
    justifyContent: "center",
    fontFamily: "Karla",
    fontWeight: "400",
    fontSize: "20px",
    color: "white",
  };

  const permission=usePermissions();
const showLimitsTabByClients = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Limits"), "clients");
const showLimitsTabByUser = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Limits"), "user");

  return (
    <div>
      <Grid
        container
        className="Grid-padding"
        sx={{ paddingLeft: "18px", paddingRight: "18px" }}
        rowSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
        columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }}
        justifyContent="space-beetween"
        alignItems="center"
      >
        {archives.map((el) => {
          const { name, path } = el;
           if (name === "Limits by Client" && !showLimitsTabByClients) return null;
            if (name === "Limits by User" && !showLimitsTabByUser) return null;
          return (
            <Grid item xs={12} sm={12} md={4} lg={3} xl={2.3} key={name}>
              <Card style={style} onClick={() => handleClick(name, path)}>
                <Typography fontSize={"20px"} fontFamily={"Karla"}>
                  {name}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default LimitsPage;
